// One option in a filter dropdown.
export interface FilterOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  // Also the accessible name — filter bars label by placeholder-ish first option ("All roles"),
  // not a visible <label>, so the aria-label is what a test or a screen reader has to go on.
  label: string;
  value: string;
  onChange: (next: string) => void;
  options: FilterOption[];
  className?: string;
}

// The filter-bar dropdown, shared by every admin list (users, exams, clips). Controlled by
// value/onChange rather than register(), because a filter is view state, never form data —
// which is also why it doesn't need the forwardRef the form-facing `Select` carries.
//
// Promoted here after the same select was hand-rolled a third time; the styling matches the
// filter bars it sits in (h-10, matching Input) rather than shared/Select's form height.
export function FilterSelect({ label, value, onChange, options, className = '' }: FilterSelectProps) {
  return (
    <select
      aria-label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={
        'h-10 rounded-sm border border-line-2 bg-surface px-2.5 pr-7 text-sm text-ink ' +
        'outline-none transition-[border-color,box-shadow] ' +
        'focus:border-ink-3 focus:shadow-[0_0_0_3px_color-mix(in_oklch,var(--ink)_10%,transparent)] ' +
        className
      }
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
